import * as React from "react";
import { Col } from "common/components";
import { useFetchEventProcedureSteps } from "security-app/hooks/useEventProceduresAPI";
import QueryHelper from "components/common/QueryHelper";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import { listElements } from "./constants";
import { columnRenderers } from "./column-renderers";
import useTableElements from "./use-table-elements";
function EventProcedureStepLibraryList({ selectedSteps }) {
  const { eventProcedureStepsEntitiesKeyFn, searchEventProcedureSteps } = useFetchEventProcedureSteps();
  const { expandedSections, bulkSelection } = useTableElements(selectedSteps);
  return /* @__PURE__ */ React.createElement(Col, { $align: "center" }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "Event Procedures Step",
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "Event Procedure Step" }),
      tableLayout: listElements.defaultLayout,
      fetchEntities: searchEventProcedureSteps,
      keyFn: eventProcedureStepsEntitiesKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      expandedSectionRenderers: expandedSections,
      bulkSelection,
      withoutURLParams: true
    }
  ));
}
export default EventProcedureStepLibraryList;
